import { MoreVertical } from 'lucide-react'

import { Button } from "../../../components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu"

export function createActionsColumn(actions, isConfigureMode = false) {
  if (!isConfigureMode) return null;

  return {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => (
      <div className="flex justify-end pr-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-8 w-8 p-0 cursor-pointer hover:bg-gray-100 focus:outline-none focus:ring-0"
            >
              <span className="sr-only">Open menu</span>
              <MoreVertical className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            side="bottom"
            sideOffset={0}
            className="bg-white border border-gray-200 shadow-lg rounded-[8px] min-w-[120px] p-1"
          >
            {actions.map((action, index) => (
              <DropdownMenuItem
                key={index}
                className="cursor-pointer hover:bg-gray-50 focus:bg-gray-50 px-3 py-2 text-sm text-gray-700 rounded-md transition-colors duration-150 focus:outline-none"
                style={{
                  letterSpacing: "0.00938em",
                  fontSize: "16px",
                  fontWeight: 500,
                  fontFamily: '"Poppins", sans-serif'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  action.onClick(row.original);
                }}
              >
                {action.icon && (
                  <span className="flex items-center">{action.icon}</span>
                )}
                {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    )
  };
}
